

import { store,localStorage } from '../../utils/';

export default {
  sessionId: null,//当前选中会话ID
  changeSessionIdMethod: null,//sessionId改变事件
  isChange: true, //当前是否可切换sessionId
  newSessionMethod: null, //新建会话事件
  refreshSessionListMethod: null, //刷新会话列表
  baseModel: store.get('baseModel') || null, //选中的基础模型
  enhancedModel: store.get('enhancedModel') || null, //选中的增强模型
  modelType: null, //获取会话的模型类型
  submitMsg: null,//新增会话请求的内容
  submitFileList: [],//新增会话上传的文件
  chatType: localStorage.get('chatType') || 1,	//聊天类型
};